import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

var _dec, _dec2, _dec3, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
// TODO: once the text prop is removed in v8.0.0 update children prop to isRequired
// NOTE: when the variant prop is removed in v8.0.0 change 'default' color to 'primary'
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { View } from '@instructure/ui-view';
import { Tooltip } from '@instructure/ui-tooltip';
import { TruncateText } from '@instructure/ui-truncate-text';
import { themeable, ThemeablePropTypes } from '@instructure/ui-themeable';
import { passthroughProps, deprecated } from '@instructure/ui-react-utils';
import { testable } from '@instructure/ui-testable';
var styles = {
  componentId: 'dLyYq',
  template: function template(theme) {
    return "\n\n.dLyYq_bGBk{background:".concat(theme.background || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";border-style:").concat(theme.borderStyle || 'inherit', ";border-width:").concat(theme.borderWidth || 'inherit', ";display:block;font-family:").concat(theme.fontFamily || 'inherit', ";line-height:calc(").concat(theme.height || 'inherit', " - ").concat(theme.borderWidth || 'inherit', "*2);padding:").concat(theme.padding || 'inherit', "}\n\n.dLyYq_bGBk,.dLyYq_eWKC{box-sizing:border-box}\n\n.dLyYq_eWKC{font-size:").concat(theme.textFontSize || 'inherit', ";font-weight:").concat(theme.textFontWeight || 'inherit', ";letter-spacing:0.0625rem;text-transform:").concat(theme.textTransformStyle || 'inherit', "}\n\n.dLyYq_ddES{border-color:").concat(theme.color || 'inherit', ";color:").concat(theme.color || 'inherit', "}\n\n.dLyYq_bXiG{border-color:").concat(theme.primaryColor || 'inherit', ";color:").concat(theme.primaryColor || 'inherit', "}\n\n.dLyYq_pypk,.dLyYq_ecos{border-color:").concat(theme.infoColor || 'inherit', ";color:").concat(theme.infoColor || 'inherit', "}\n\n.dLyYq_cOXX{border-color:").concat(theme.successColor || 'inherit', ";color:").concat(theme.successColor || 'inherit', "}\n\n.dLyYq_zGXc{border-color:").concat(theme.dangerColor || 'inherit', ";color:").concat(theme.dangerColor || 'inherit', "}\n\n.dLyYq_eRqw{border-color:").concat(theme.warningColor || 'inherit', ";color:").concat(theme.warningColor || 'inherit', "}\n\n.dLyYq_elxg{border-color:").concat(theme.messageColor || 'inherit', ";color:").concat(theme.messageColor || 'inherit', "}\n\n.dLyYq_bgqc{border-color:").concat(theme.alertColor || 'inherit', ";color:").concat(theme.alertColor || 'inherit', "}");
  },
  'root': 'dLyYq_bGBk',
  'text': 'dLyYq_eWKC',
  'default': 'dLyYq_ddES',
  'primary': 'dLyYq_bXiG',
  'info': 'dLyYq_pypk',
  'oldPrimary': 'dLyYq_ecos',
  'success': 'dLyYq_cOXX',
  'danger': 'dLyYq_zGXc',
  'warning': 'dLyYq_eRqw',
  'message': 'dLyYq_elxg',
  'alert': 'dLyYq_bgqc'
};
import theme from "./theme.js";
/**
---
category: components
---
**/

var Pill = (_dec = testable(), _dec2 = deprecated('8.0.0', {
  text: 'children',
  variant: 'color'
}), _dec3 = themeable(theme, styles), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Pill, _Component);

  var _super = _createSuper(Pill);

  function Pill(props) {
    var _this;

    _classCallCheck(this, Pill);

    _this = _super.call(this, props);
    _this.state = {
      truncated: false
    };
    return _this;
  }

  _createClass(Pill, [{
    key: "handleTruncation",
    value: function handleTruncation(truncated) {
      this.setState({
        truncated: truncated
      });
    }
  }, {
    key: "renderPill",
    value: function renderPill(focused, getTriggerProps) {
      var _classnames,
          _this2 = this;

      var _this$props = this.props,
          margin = _this$props.margin,
          children = _this$props.children,
          variant = _this$props.variant,
          color = _this$props.color,
          as = _this$props.as,
          elementRef = _this$props.elementRef,
          text = _this$props.text,
          props = _objectWithoutProperties(_this$props, ["margin", "children", "variant", "color", "as", "elementRef", "text"]);

      var filteredProps = passthroughProps(props);
      var containerProps = typeof getTriggerProps === 'function' ? getTriggerProps(filteredProps) : filteredProps;
      var actualColor = variant;

      if (!actualColor) {
        // usng new color props
        actualColor = color;
      } else {
        // using old variant
        if (variant === 'primary') {
          actualColor = 'oldPrimary';
        }
      }

      var classes = classnames((_classnames = {}, _defineProperty(_classnames, styles.root, true), _defineProperty(_classnames, styles.truncated, this.state.truncated), _defineProperty(_classnames, styles[actualColor], true), _classnames));
      return /*#__PURE__*/React.createElement(View, Object.assign({}, containerProps, {
        as: as,
        elementRef: elementRef,
        margin: margin,
        padding: "0",
        maxWidth: this.theme.maxWidth,
        background: "transparent",
        borderRadius: "pill",
        borderWidth: "0",
        display: "inline-block",
        position: "relative",
        withFocusOutline: focused,
        focusColor: "info"
      }), /*#__PURE__*/React.createElement("span", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.text
      }, /*#__PURE__*/React.createElement(TruncateText, {
        onUpdate: function onUpdate(truncated) {
          _this2.handleTruncation(truncated);
        }
      }, children || text))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.state.truncated) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          renderTip: this.props.children || this.props.text
        }, function (_ref) {
          var focused = _ref.focused,
              getTriggerProps = _ref.getTriggerProps;
          return _this3.renderPill(focused, getTriggerProps);
        });
      } else {
        return this.renderPill();
      }
    }
  }]);

  Pill.displayName = "Pill";
  return Pill;
}(Component), _class2.propTypes = {
  as: PropTypes.elementType,
  // eslint-disable-line react/require-default-props
  children: PropTypes.node,
  color: PropTypes.oneOf(['primary', 'success', 'danger', 'info', 'warning', 'alert']),
  elementRef: PropTypes.func,

  /**
   * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
   * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
   * familiar CSS-like shorthand. For example: `margin="small auto large"`.
   */
  margin: ThemeablePropTypes.spacing,

  /* eslint-disable react/require-default-props */

  /**
   * __Deprecated - use 'children'__
   */
  text: PropTypes.node,

  /**
   * __Deprecated - use 'color'__
   */
  variant: PropTypes.oneOf(['default', 'success', 'danger', 'primary', 'warning', 'message'])
  /* eslint-enable react/require-default-props */

}, _class2.defaultProps = {
  children: void 0,
  margin: void 0,
  elementRef: void 0,
  color: 'primary'
}, _temp)) || _class) || _class) || _class);
export default Pill;
export { Pill };